import { render, staticRenderFns } from "./TrekkingRevenueOfficeWise.vue?vue&type=template&id=8893ebb6&"
import script from "./TrekkingRevenueOfficeWise.vue?vue&type=script&lang=js&"
export * from "./TrekkingRevenueOfficeWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports